import React, { Component } from "react";
import { observer } from "mobx-react";
import { Link } from "react-router-dom";
import { Form, Checkbox, Button, Input } from "semantic-ui-react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import TourbuzzLogo from "~/img/tb-logo-tagline.svg";
import DomainNameUtils from "~/utils/DomainNameUtils";
import LoginStore from "../stores/LoginStore";
import FlashMessageStore from "~/stores/FlashMessageStore";
import FlashMessage from "~/components/FlashMessage";
import CustomDomainLogo from "~/components/CustomDomainLogo";

@observer
class LoginForm extends Component {
  render() {
    const { continueURL, loginStore, flashMessageStore, t } = this.props;

    let logo;

    if (DomainNameUtils.isTourbuzz()) {
      logo = <img src="/skins/tourbuzz/default/shared/img/new_TB_logo_color_eng.svg" alt="Tourbuzz Logo" />;
    } else if (DomainNameUtils.isMyUrbanimmersive()) {
      logo = <img src={TourbuzzLogo} alt="Tourbuzz Logo" style={{ width: "150px" }} />;
    } else {
      logo = (
        <CustomDomainLogo
          logoUrl={window.templateDefaults.customBranding.logoUrl}
          company={window.templateDefaults.customBranding.company}
        />
      );
    }

    return (
      <div>
        <div className="logo">{logo}</div>
        <Form
          loading={loginStore.isLoginIn || loginStore.isRedirecting}
          error={flashMessageStore.message && flashMessageStore.type === "negative"}
          success={flashMessageStore.message && flashMessageStore.type === "positive"}
        >
          <FlashMessage flashMessageStore={flashMessageStore} />
          <Form.Field className="login-form-username" error={loginStore.isLoginError}>
            <label className="login-form-username-label">{t("login:username")}</label>
            <Input
              icon="user"
              iconPosition="left"
              placeholder={t("login:username")}
              value={loginStore.username}
              onChange={data => {
                loginStore.username = data.target.value;
              }}
            />
          </Form.Field>
          <Form.Field className="login-form-password" error={loginStore.isLoginError}>
            <label className="login-form-password-label">{t("login:password")}</label>
            <Input
              icon="lock"
              iconPosition="left"
              placeholder={t("login:password")}
              type="password"
              value={loginStore.password}
              onChange={data => {
                loginStore.password = data.target.value;
              }}
            />
          </Form.Field>
          <Button
            primary
            fluid
            className="login-form-submit-btn"
            type="submit"
            onClick={() => {
              loginStore.login(continueURL).then(() => {
                if (loginStore.isLoginError) {
                  flashMessageStore.setMessage(loginStore.loginErrorMessage, "negative");
                }
              });
            }}
            disabled={!loginStore.canLogin || loginStore.isLoginIn}
          >
            {t("login:login")}
          </Button>
          <div className="login-form-aux-container">
            <Form.Field className="login-form-remember-me">
              <Checkbox
                label={t("login:rememberMe")}
                checked={loginStore.isRememberMe}
                onChange={(data, value) => {
                  loginStore.isRememberMe = value.checked;
                }}
              />
            </Form.Field>
            <p className="login-form-forgot-creds">
              <Link to="/doForgotPassword">{t("login:forgotUsernamePassword")}</Link>
            </p>
          </div>
        </Form>
      </div>
    );
  }
}

LoginForm.propTypes = {
  loginStore: PropTypes.instanceOf(LoginStore).isRequired,
  flashMessageStore: PropTypes.instanceOf(FlashMessageStore).isRequired,
  continueURL: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(LoginForm);
